var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contentContainer"},[_c('v-layout',{staticClass:"elementPanel",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('MediaComponent',{attrs:{"mediaFilters":_vm.mediaFilters}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }